import { useState, useEffect } from "react";
import { ReferralService } from "../../../../services";

const useReferralRedemptions = () => {
  const [redemptions, setRedemptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [referralsRewardItems, setReferralsRewardItems] = useState([]);

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token"));
    const fetchRedemptions = async () => {
      try {
        const response = await ReferralService.getRedemptions(token);
        setRedemptions(response);
      } catch (error) {
        setError(error);
        console.log("Error", error)
      } finally {
        setLoading(false);
      }
    };

    const fetchRedemptionRewards = async () => {
      try {
        const response = await ReferralService.getRewards(token);
        setReferralsRewardItems(response);
      } catch (error) {
        setError(error);
        console.log("Error", error)
      } finally {
        setLoading(false);
      }
    }

    fetchRedemptionRewards();
    fetchRedemptions();
  }, []);


  return { redemptions, loading, error, referralsRewardItems };
}

export default useReferralRedemptions;